// src/route/router.jsx
import { createBrowserRouter } from "react-router-dom";

import RootLayout from "../layout/root";
import Home from "../App";
import About from "../pages/about";
import Blog from "../pages/blog";
import BlogDetails from "../pages/blog-details";
import LayoutTwo from "../layout/layoutTwo";
import HomeTwo from "../pages/home-2";
import Contact from "../pages/contact";
import Faq from "../pages/faq";
import Testimonials from "../pages/testimonials";
import HomeThree from "../pages/home-3";
import ServiceDetails from "../pages/service-details";
import Services from "../pages/services";
import TermsConditions from "../pages/terms-conditions";
import PrivacyPolicy from "../pages/privacy-policy";
import SearchResult from "../pages/search-result";
import Register from "../pages/register";
import Profile from "../pages/profile";
import VerifyEmail from "../pages/VerifyEmail";
import Team from "../pages/team";
import Contract from "../pages/contract";
import ContractTemplate from "../pages/contract-template";
import AddContractTemplate from "../pages/AddContractTemplate";
import Pricing from "../pages/pricing";
import Login from "../pages/login";
import NotFound from "../pages/404";
import Author from "../pages/author";
import Categories from "../pages/categories";
import PurchasePointCompleted from "../pages/PurchasePointCompleted";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    errorElement: <NotFound />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/dashboard", element: <Home /> },
    ],
  },
  {
    path: "/",
    element: <LayoutTwo />,
    children: [
      { path: "/home-2", element: <HomeTwo /> },
      { path: "/home-3", element: <HomeThree /> },
      { path: "/service-details", element: <ServiceDetails /> },
      { path: "/services", element: <Services /> },
      { path: "/contact", element: <Contact /> },
      { path: "/blog", element: <Blog /> },
      { path: "/blog-details", element: <BlogDetails /> },
      { path: "/about", element: <About /> },
      { path: "/faq", element: <Faq /> },
      { path: "/testimonials", element: <Testimonials /> },
      { path: "/contract", element: <Contract /> },
      { path: "/contract-template/:contractType", element: <ContractTemplate /> },
      { path: "/add-contract-template", element: <AddContractTemplate />},
      { path: "/team", element: <Team /> },
      { path: "/pricing", element: <Pricing /> },
      { path: "/terms-conditions", element: <TermsConditions /> },
      { path: "/privacy-policy", element: <PrivacyPolicy /> },
      { path: "/search-result", element: <SearchResult /> },
      { path: "/register", element: <Register /> },
      { path: "/profile", element: <Profile /> },
      { path: "/verify/:token", element: <VerifyEmail /> },
      { path: "/login", element: <Login /> },
      { path: "/author", element: <Author /> },
      { path: "/categories", element: <Categories /> },
      { 
        path: "/purchase-point-completed", 
        element: <PurchasePointCompleted /> // Add new route 
      },
    ],
  },
  {
    future: {
      v7_startTransition: true,
      v7_relativeSplatPath: true,
      v7_fetcherPersist: true,
      v7_normalizeFormMethod: true,
      v7_partialHydration: true,
      v7_skipActionErrorRevalidation: true,
    },
  }
]);


